import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiArrowRight } from 'react-icons/fi';

const CTAButton = ({ text, className = '' }) => {
  const affiliateLink = "https://f6f7eaq2sz61wda0od6eu6xmt7.hop.clickbank.net/?&traffic_source=facebook";

  return (
    <div className={`flex flex-col items-center w-full ${className}`}>
      <a
        href={affiliateLink}
        target="_blank"
        rel="noopener noreferrer"
        className="w-full max-w-md bg-teal-600 hover:bg-teal-700 text-white text-center font-bold text-lg sm:text-xl py-5 px-6 rounded-xl shadow-[0_8px_20px_rgba(13,148,136,0.3)] transform transition-transform duration-300 hover:-translate-y-1 flex items-center justify-center gap-3 animate-pulse-slow"
      >
        <span>{text}</span>
        <SafeIcon icon={FiArrowRight} className="text-2xl flex-shrink-0" />
      </a>
      <div className="mt-3 flex items-center gap-2 text-sm text-slate-500 font-medium">
        <SafeIcon icon="Shield" className="text-teal-600" />
        <span>Backed by a 180-Day 100% Money Back Guarantee</span>
      </div>
    </div>
  );
};

export default CTAButton;